export const TYPES = {
  CUSTOMER: 'A1',
  SHIPPER: 'A2',
  MANAGER: 'A3',
  ADMINISTRATOR: 'A4',
  STOREKEEPER: 'A5',
  STOCK_INFO: 'A6',
  MANAGER_WAREHOUSE: 'A7',
  WEBSITE_MODERATOR: 'A8',
  STORE_WH: 'A9',
  ACCOUNTANT: 'A10',
}

export const EMPLOYEE_TYPES = [
  TYPES.MANAGER,
  TYPES.ADMINISTRATOR,
  TYPES.STOREKEEPER,
  TYPES.STOCK_INFO,
  TYPES.MANAGER_WAREHOUSE,
  TYPES.WEBSITE_MODERATOR,
  TYPES.STORE_WH,
  TYPES.ACCOUNTANT,
]

export const USER_TYPES = {
  [TYPES.CUSTOMER]: { isCustomer: true },
  [TYPES.SHIPPER]: { isShipper: true },
  [TYPES.MANAGER]: { isManager: true },
  [TYPES.ADMINISTRATOR]: { isAdministrator: true },
  [TYPES.STOREKEEPER]: { isStoreKeeper: true },
  [TYPES.STOCK_INFO]: { isStockInfo: true },
  [TYPES.MANAGER_WAREHOUSE]: { isManagerWarehouse: true },
  [TYPES.WEBSITE_MODERATOR]: { isWebsiteModerator: true },
  [TYPES.STORE_WH]: { isStoreWH: true },
  [TYPES.ACCOUNTANT]: { isAccountant: true },
}

export const REDIRECT_MAP = {
  [TYPES.CUSTOMER]: 'profile:order:list',
  [TYPES.SHIPPER]: 'profile:order:list',
  [TYPES.MANAGER]: 'profile:order:list',
  [TYPES.ADMINISTRATOR]: 'profile:order:list',
  [TYPES.STOREKEEPER]: 'profile:order:list',
  [TYPES.STOCK_INFO]: 'profile:order:list',
  [TYPES.MANAGER_WAREHOUSE]: 'profile:order:list',
  [TYPES.WEBSITE_MODERATOR]: 'profile:order:list',
  [TYPES.STORE_WH]: 'profile:order:list',
  [TYPES.ACCOUNTANT]: 'profile:order:list',
}
